export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11762.a2b17147.jpg";